import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ProductService } from '../../../shared/services/product.service';
import { CartsService } from '../../../shared/services/carts.service';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgFor, NgIf, TitleCasePipe, CurrencyPipe } from '@angular/common';
import { API_URLS, PRODUCT_PATH } from '../../../config/app.constants';
import { HttpinterceptorService } from '../../../shared/services/httpinterceptor.service';

@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.scss'],
  standalone: true,
  imports: [NgFor, NgbTooltip, NgIf, TitleCasePipe, CurrencyPipe]
})
export class WishlistComponent implements OnInit {

  wishlists: any[] = [];

  imagePath = PRODUCT_PATH;

  cartDetailsToSend = {
    product_id: '',
    quantity: 0,
    guest_id: '',
    item_type: '',
    is_renewable: false
  };

  constructor(
    private http: HttpinterceptorService,
    private router: Router,
    private cartsService: CartsService,
    private productService: ProductService
  ) { }

  ngOnInit() {
    this.getWishlist();
  }

  getWishlist() {
    this.http.post(API_URLS.GET_WISHLIST, {}, false).subscribe(
      response => {
        if (response.type === 'success' && response.code === 200) {
          this.wishlists = response.data;
        }
      });
  }

  addProductToCart(product) {
    this.cartDetailsToSend.product_id = product.product_id;
    this.cartDetailsToSend.item_type = 'product';
    this.cartDetailsToSend.quantity = 1;
    this.productService.addToCart(this.cartDetailsToSend).subscribe(
      response => {
        if (response.type === 'success' && response.code === 200) {
          this.cartsService.getCartWithApi();
        }
      },
      error => {
        return false;
      });
  }

  removeFromWishlist(product) {
    this.productService.removeFromWishlist(product.product_id).subscribe(
      response => {
        if (response.type === 'success' && response.code === 200) {
          this.getWishlist();
        }
      },
      error => {
        return false;
      });
  }

}
